import { ProjectMap, FilteredProjectMap } from '../Components/ProjectTypes';

export enum LAYOUT_STATE {
    PHONE_NUMBER,
    PROJECT_LIST,
    SINGLE_PROJECT,
};

export type StaticState = {
    projectInfo: ProjectMap;
    phoneNumber: number;
}

export type DynamicState = {
    layoutState: LAYOUT_STATE;
    layoutBasedState: LayoutBasedState;
}

export type LayoutBasedState = {
    phoneNumberState?: PhoneNumberState;
    projectListState?: ProjectListState;
    singleProjectState?: SingleProjectState;
}

export type PhoneNumberState = {
}

export type ProjectListState = {
    filteredProjects: FilteredProjectMap;
}

export type SingleProjectState = {
    currentProjectKey: string;
}

export type SiteState = {
    staticState: StaticState;
    dynamicState: DynamicState;
}

export type ServerWebsocketData = {
    phoneNumber: number;
    dynamicSiteState: DynamicState;
}